import { CaretDownIcon } from '@/common/components/icons'
import {
  Popover,
  PopoverPanel,
  Transition,
  PopoverButton as PopoverButtonHeadless
} from '@headlessui/react'
import { useTranslation } from 'react-i18next'
import { PopoverToggleButton } from '@/common'

const menuItemClasses =
  'block p-2 w-full cursor-pointer text-left font-medium text-sm rounded-xs hover:bg-green-500 transition-colors duration-200'

export default function OnboardingUserMenu({
  onLogout,
  fullName,
  email
}: {
  fullName: string
  onLogout: () => Promise<void>
  email: string
}) {
  const { t } = useTranslation()
  return (
    <div className="w-48">
      <Popover>
        <PopoverToggleButton>
          <div className="space-y-1 text-left">
            <div className="font-semibold text-sm break-words">{fullName}</div>
          </div>
          <CaretDownIcon className="flex-shrink-0 size-6 text-gray-500" />
        </PopoverToggleButton>
        <Transition
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <PopoverPanel
            transition
            anchor="top end"
            className="z-40 transition shadow-dropdown border p-2 rounded-xs bg-white duration-200 ease-in-out [--anchor-gap:8px] data-[closed]:-translate-y-1 data-[closed]:opacity-0"
          >
            <section className="space-y-2 min-w-48">
              <div className="text-sm p-2 text-gray-600 font-medium">{email}</div>
              <PopoverButtonHeadless className={menuItemClasses} as="button" onClick={onLogout}>
                {t('common:actions.logout')}
              </PopoverButtonHeadless>
            </section>
          </PopoverPanel>
        </Transition>
      </Popover>
    </div>
  )
}
